import {useEntityMutation} from '@/hooks/useEntityMutation'
import type {UseMutationResult} from '@tanstack/react-query'
import {useServices} from '@/services/context'
import {useI18n} from '@/i18n'
import {EXECUTION_KEY, EXECUTION_TASKS_KEY} from './useExecution'

export interface ExecutionMutations {
    /**
     * Cancel a RUNNING / PENDING / CANCELLING execution. Invalidates the
     * execution detail and task tree on success; the live SSE stream and
     * the cached page data converge on the new status from the next refetch.
     */
    cancel: UseMutationResult<void, Error, void>
}

export function useExecutionMutations(id: string | undefined): ExecutionMutations {
    const services = useServices()
    const i18n = useI18n()

    const cancel = useEntityMutation({
        mutationFn: () => services.jobs.cancelExecution(id!),
        invalidate: [[EXECUTION_KEY, id], [EXECUTION_TASKS_KEY, id]],
        successMessage: i18n.jobExecutions.executionCancelled,
    })

    return {cancel}
}
